import { Record } from 'immutable';

import { UserType } from 'enums/user-type';
import Hydrator from 'utils/Hydrator';
import Entity from './Entity';

const ApiUserRecord = Record({
  id: 0,
  name: '',
  email: '',
  phoneNumber: '',
  userType: UserType.business,
  entity: null,
});

export default class ApiUser extends ApiUserRecord {
  static deserialize(jsonObject = {}) {
    if (typeof jsonObject === 'undefined' || jsonObject === null) {
      return undefined;
    }

    const mapProperties = {
      entity: Entity.deserialize,
    };

    const hydrated = Object.keys(jsonObject).reduce(Hydrator.assign(jsonObject, mapProperties), {});

    return new ApiUser(hydrated);
  }
}
